import { render, staticRenderFns } from "./AddCPBook.vue?vue&type=template&id=5cbca053&"
import script from "./AddCPBook.vue?vue&type=script&lang=js&"
export * from "./AddCPBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports